<template>
  <div>
    <headline
      :content="$t('project.plan', { name: '' })"
    />
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <div v-if="!isLoading">
          <ProjectPlanArea
            v-if="project"
            :projectId="project.objectId"
            :isEdit="true" 
          />
        </div>
        <v-card class="d-flex justify-center py-10" elevation="0" v-else>
          <v-progress-circular
            indeterminate
            size="64"
            color="green"
          ></v-progress-circular>
        </v-card>
      </template>
    </layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
  </div>
</template>

<script>
import ConfirmDialog from "@/components/ConfirmDialog.component.vue"
import { mapState } from "vuex"
import Layout from "../../components/Layout"
import Headline from "../../components/Headline"
import ProjectPlanArea from "../../components/ProjectPlanArea.vue";
export default {
  data(){
    return {
      projectId: this.$route.params.projectId,
      isLoading: false,
      isError: false,
      isSuccess: false,
    }
  },
  components: {
    ConfirmDialog,
    Layout,
    Headline,
    ProjectPlanArea
  },
  computed: {
    ...mapState({
      // bankAccounts: state => state.bankAccount.bankAccounts,p
    }),
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
  },
  async created(){
    this.project = this.admins[0].project
    this.isLoading = true
    try{
      // await this.$store.dispatch("bankAccount/getBankAccounts", this.projectId)
      this.isLoading = false
    }catch(error){
      this.isLoading = false
      this.isError = true
    }
  },
  methods: {

  },
}
</script>